/* global require */
import _ from 'underscore';

const components = {
    'account-settings': 'account-settings/index',
    'bt-subscription-form': 'bt-subscription-form',
    'member-email-preferences': 'email-preferences',
    'password-reset': 'password-reset',
    'password-reset-set': 'password-reset-set',
    'profiles-manager': 'profiles/manager',
    'sms-preferences': 'sms-preferences',
    'transaction-history': 'transaction-history',
    'your-tarot-deck': 'account-settings/your-tarot-deck',
};

const sagas = [
    'email-preferences',
];

import(/* webpackMode: "weak" */ '../app/index')
    .then((index) => {
        sagas.map(name => {
            const saga = require(`./sagas/${name}`).root;
            index.registerSaga(saga);
        });

        _.each(components, (path, tag) => {
            const { default: Component } = require(`./components/${path}`);
            index.register(tag, Component);
        });
    })
    .catch(() => {});